/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Brick, registerBrick } from 'olympe';

export default class CenterOrMiddle extends Brick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {number} containerWidth
     * @param {number} elementWidth
     * @param {function(number)} setResult
     */
    update(context, [containerWidth, elementWidth], [setResult]) {
        setResult((containerWidth - elementWidth) / 2);
    }
}

registerBrick('016f8a9d9ea15c1f31c2', CenterOrMiddle);
